module.exports = __webpack_public_path__ + "static/media/testtube.f11d2a08.svg";